import { useState } from 'react';
import { Box } from '@mui/material';
import Sidebar from './components/Sidebar';
import MainContent from './components/MainContent';

const ExposedAPIV2 = () => {
    const [activeSection, setActiveSection] = useState('introduction');

    const handleSectionChange = (sectionId) => {
        setActiveSection(sectionId);
    };

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#fff' }}>
            <Sidebar
                activeSection={activeSection}
                onSectionChange={handleSectionChange}
            />
            <MainContent activeSection={activeSection} />
        </Box>
    );
};

export default ExposedAPIV2;
